import { atom } from "jotai";
import { InvoicePreview, PlanData } from "shared/datamodel/schemas/billing";

export const plansDataAtom = atom<PlanData[]>([]);
export const invoicePreviewsAtom = atom<InvoicePreview[] | null>(null);
